import { render, staticRenderFns } from "./DetailSave.vue?vue&type=template&id=3631b52a&scoped=true"
import script from "./DetailSave.vue?vue&type=script&lang=js"
export * from "./DetailSave.vue?vue&type=script&lang=js"
import style0 from "./DetailSave.vue?vue&type=style&index=0&id=3631b52a&prod&lang=css"
import style1 from "./DetailSave.vue?vue&type=style&index=1&id=3631b52a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3631b52a",
  null
  
)

export default component.exports